import { render, staticRenderFns } from "./ArticleSection.vue?vue&type=template&id=08281c9c&scoped=true"
import script from "./ArticleSection.vue?vue&type=script&lang=js"
export * from "./ArticleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08281c9c",
  null
  
)

export default component.exports